import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Logo from '@/components/Logo';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-coal/40" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-dune">
              An Indian spice trading house moving turmeric and cardamom from origin farms to
              buyers worldwide — and across India. Direct, tested, and priced to move.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] font-medium uppercase tracking-[0.28em] text-turmeric">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ['Home', '/'],
                ['Spices', '/products'],
                ['About', '/about'],
                ['Request a Quote', '/contact'],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-bone/80 transition-colors duration-300 hover:text-turmeric" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, '-')}`}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] font-medium uppercase tracking-[0.28em] text-turmeric">Trade Desk</p>
            <ul className="mt-5 space-y-3 text-sm text-bone/80">
              <li data-testid="footer-person-tj">
                TJ Mohan Raja — <a href="tel:+917418042004" className="transition-colors duration-300 hover:text-turmeric">+91 74180 42004</a>
              </li>
              <li data-testid="footer-partner">
                Abishek Pandian — <a href="tel:+918056965236" className="transition-colors duration-300 hover:text-turmeric">+91 80569 65236</a>
              </li>
              <li data-testid="footer-address" className="leading-relaxed text-dune/80">
                1483/6, Tara Apartments, 13th Main Road, Anna Nagar, Block J, Chennai, Tamil Nadu 600040, India
              </li>
              <li data-testid="footer-branch" className="leading-relaxed text-dune/80">
                70/9, Nega Complex, Main Road, Vasudevanallur, Tenkasi, Tamil Nadu 627758
              </li>
              <li data-testid="footer-gstin" className="text-dune/80">GSTIN — 33FQEPM5841N1ZE</li>
              <li data-testid="footer-email" className="text-dune/60">
                <a href="mailto:tjmohan@equinoxspices.com" className="transition-colors duration-300 hover:text-turmeric">tjmohan@equinoxspices.com</a>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-6 inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.18em] text-turmeric transition-colors duration-300 hover:text-bone"
            >
              Start an enquiry
              <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={2} />
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 text-[12px] text-dune/70 sm:flex-row sm:items-center sm:justify-between">
          <span data-testid="footer-copyright">© {year} EQUINOX SPICES</span>
          <span>Prices on request — we quote against live markets, not rate cards.</span>
        </div>
      </div>
    </footer>
  );
}
